module.exports = __webpack_public_path__ + "static/img/PC-3.abf2618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/PC-3.png
// module id = AF45
// module chunks = 0